import React from "react"
import { Container, Typography, Button, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { Link } from "gatsby-theme-material-ui"
import Xing from "../components/icons/social/Xing"
import Facebook from "../components/icons/social/Facebook"
import LinkedIn from "../components/icons/social/LinkedIn"
import GitHub from "../components/icons/social/GitHub"
import Twitter from "../components/icons/social/Twitter"
import GooglePlus from "../components/icons/social/GooglePlus"
import Medium from "../components/icons/social/Medium"

const KontaktSectionStyle = theme => ({
  root: {
    paddingTop: theme.spacing(8),
  },
  fragen: {
    marginTop: theme.spacing(1),
    // [theme.breakpoints.down('sm')]: {
    //     textAlign: 'center',
    // }
  },
  buttonBlock: {
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-evenly",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  },
  vcard: {
    display: "inline-block",
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      display: "block",
      marginTop: theme.spacing(1),
    },
  },
  button: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  socialSection: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(1),
  },
  socialIcons: {
    height: "4rem",
    width: "auto",
    marginRight: theme.spacing(2),
  },
})

const useStyles = makeStyles(KontaktSectionStyle)

const handleEmail = () => {
  if (typeof window !== "undefined") {
    window.location = "mailto:fragen@heissenberger.at"
  }
}

const handlePhoneCall = () => {
  if (typeof window !== "undefined") {
    window.location = "tel:+436641207620"
  }
}

const handleVCARD = () => {
  if (typeof window !== "undefined") {
    window.location = "/assets/contacts/heissenberger_laboratory.vcf"
  }
}

export default function KontaktSection() {
  const classes = useStyles()
  return (
    <Container
      maxWidth="lg"
      className={classes.root}
      id="kontakt"
      component="section"
    >
      <Typography variant="h2">Ready for a good relationship?</Typography>
      <Typography variant="h5" color="textSecondary" className={classes.fragen}>
        Send us your questions via <br />
        <Grid
          container
          spacing={2}
          alignItems="center"
          className={classes.buttonBlock}
        >
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleEmail}
              className={classes.button}
            >
              Email to fragen&#173;@&#173;heissenberger.&#173;at
            </Button>
          </Grid>
          <Grid item xs={12} md={1} style={{ textAlign: "center" }}>
            or
          </Grid>
          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={handlePhoneCall}
              className={classes.button}
            >
              call ＋43‑664‑120‑7620 an
            </Button>
          </Grid>
        </Grid>
        and make an appointment for a conversation. We look forward to the first
        conversation.
      </Typography>
      <Typography
        variant="h5"
        color="textSecondary"
        component="p"
        className={classes.fragen}
      >
        Add contact information to the address book
        <div className={classes.vcard}>
          <Button
            variant="outlined"
            color="primary"
            component={Link}
            onClick={handleVCARD}
          >
            vCard export
          </Button>
        </div>
      </Typography>

      <Typography variant="h5" className={classes.socialSection}>
        Network with us:
      </Typography>
      <div>
        <Link
          href="http://at.linkedin.com/in/andreasheissenberger/en"
          rel="noopener"
          target="_blank"
          title="LinkedIn Andreas Heissenberger"
        >
          <LinkedIn className={classes.socialIcons} />
        </Link>
        <Link
          href="https://www.xing.com/profile/Andreas_Heissenberger"
          rel="noopener"
          target="_blank"
          title="Xing Andreas Heissenberger"
        >
          <Xing className={classes.socialIcons} />
        </Link>
        <Link
          href="http://twitter.com/AHeissenberger"
          rel="noopener"
          target="_blank"
          title="Twitter Andreas Heissenberger"
        >
          <Twitter className={classes.socialIcons} />
        </Link>
        <Link
          href="https://plus.google.com/u/0/109589628633687228723?rel=author"
          rel="noopener"
          target="_blank"
          title="Google+ Andreas Heissenberger"
        >
          <GooglePlus className={classes.socialIcons} />
        </Link>
        <Link
          href="http://www.facebook.com/andreas.heissenberger"
          rel="noopener"
          target="_blank"
          title="facebook Andreas Heissenberger"
        >
          <Facebook className={classes.socialIcons} />
        </Link>
        <Link
          href="https://github.com/aheissenberger"
          rel="noopener"
          target="_blank"
          title="GitHub Andreas Heissenberger"
        >
          <GitHub className={classes.socialIcons} />
        </Link>
        <Link
          href="https://medium.com/@andreasheissenberger"
          rel="noopener"
          target="_blank"
          title="Medium Andreas Heissenberger"
        >
          <Medium className={classes.socialIcons} />
        </Link>
      </div>
    </Container>
  )
}
